export default __webpack_public_path__ + "static/media/down.378041e7.svg";